import { EqContext, equtils } from '@easyquery/core';
import { QueryEx } from './query/query_ex';
import { EqServerQueryStorage } from './main/eqs_query_storage';
import { DataModelEx } from './dm/model_ex';
import { lcv } from './utils/lcv';
import { DataTableAggregatesCalculator } from './data/data_table_aggr_calculator';
import { LCDialog, showNoLicenseAlert } from './license/lc-dialog';
EqContext.prototype.setLicenseKeyEndpoint = function (endpoint) {
    console.warn('This method is deprecated and will be ignored.\n '
        + 'The main EasyQuery endpoint (set via useEndpoint() function) is used to get the license since version 7.0.\n '
        + 'So, you can simply remove this function call');
};
EqContext.prototype.useEnterprise = function (keyOrInitCallback) {
    var _this = this;
    var func = function (key, showAlert) {
        lcv.ck(key);
        if (lcv.__kt > 1) {
            var services = _this.getServices();
            services.registerDataModelResolver(function (context) { return new DataModelEx(); });
            services.registerQueryResolver(function (context) { return new QueryEx(context.getModel()); });
            services.registerQueryStorageResolver(function (context) { return new EqServerQueryStorage(context); });
            services.registerAggregatesCalculator(function (context) { return new DataTableAggregatesCalculator(context); });
            if (lcv.__kt === 2) {
                console.warn('EasyQuery.JS is working in the TRIAL MODE!\n'
                    + 'Please order a license (https://korzh.com/eq) to get a proper product key.');
                createTrialWM();
                setTimeout(function () {
                    showTrialWM();
                    setTimeout(hideTrialWM, 6000);
                }, 3000);
            }
        }
        else {
            if (showAlert) {
                showNoLicenseAlert(lcv);
            }
            else {
                var lcd = new LCDialog(_this);
                lcd.show();
            }
        }
    };
    if (typeof (keyOrInitCallback) === "string") {
        func(keyOrInitCallback, true);
    }
    else if (typeof (keyOrInitCallback) === "function") {
        var http_1 = this.getServices().getHttpClient();
        var url_1 = equtils.combinePath(this.getBaseEndpoint(), 'lck2');
        http_1.get(url_1)
            .then(function (result) {
            func(result.key.split("").reverse().join(""), false);
            _this.useBackend({
                type: result.backendType,
                subType: result.appType
            });
            keyOrInitCallback();
        })
            .catch(function (error) {
            url_1 = equtils.combinePath(_this.getBaseEndpoint(), 'lck');
            http_1.get(url_1)
                .then(function (result) {
                func(result.split("").reverse().join(""), false);
                keyOrInitCallback();
            })
                .catch(function (error) { return _this.throwError({
                action: "LCK",
                sourceError: error
            }); });
        });
    }
    else {
        throw new Error("Wrong type of 'keyOrInitCallback' parameter. It must be a string with a license key or a callback function.");
    }
};
var trialDiv;
function createTrialWM() {
    // we can rewrite it using shadow dom
    // to make it impossible to hide using JS :)
    trialDiv = document.createElement("div");
    trialDiv.style.position = "fixed";
    trialDiv.style.bottom = "0";
    trialDiv.style.right = "-400px";
    trialDiv.style.width = "400px";
    trialDiv.style.height = "100px";
    trialDiv.style.color = "grey";
    trialDiv.style.textAlign = "center";
    trialDiv.style.opacity = "0.7";
    trialDiv.style.font = "bold 1em Trebuchet MS, Tahoma, Verdana, Geneva, Arial, Helvetica, sans-serif";
    trialDiv.style.transition = "right 3s ease-out";
    var header = document.createElement("div");
    var eq = document.createElement("span");
    eq.innerText = "EasyQuery";
    eq.style.color = "#3A94D4";
    eq.style.lineHeight = "50px";
    header.appendChild(eq);
    var korzh = document.createElement("span");
    korzh.innerText = "by Korzh.com";
    korzh.style.marginLeft = "10px";
    header.appendChild(korzh);
    trialDiv.appendChild(header);
    var trialOnly = document.createElement("div");
    trialOnly.innerText = "FOR TRIAL USE ONLY";
    trialOnly.style.fontSize = "1.2em";
    trialOnly.style.fontWeight = "1000";
    trialDiv.appendChild(trialOnly);
    document.body.appendChild(trialDiv);
}
function showTrialWM() {
    if (trialDiv) {
        trialDiv.style.right = "0";
    }
}
function hideTrialWM() {
    if (trialDiv) {
        trialDiv.style.right = "-400px";
        setTimeout(function () {
            trialDiv.parentNode.removeChild(trialDiv);
        }, 5000);
    }
}
//# sourceMappingURL=extensions.js.map